import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import Vant from 'vant'
import 'vant/lib/index.css'

Vue.config.productionTip = false

// PC端继续使用 Element UI
Vue.use(ElementUI)

// 手机端使用 Vant
Vue.use(Vant)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')